module.exports = __webpack_public_path__ + "static/media/baseline-history-selected-24px.54aa98b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/baseline-history-selected-24px.svg
// module id = 771
// module chunks = 0